import React from "react";
import LoginRoutes from "./loginRoutes";
import MainRoutes from "./mainRoutes";
import { useSelector } from "react-redux";
import { Loader } from "../components/customLoader";

const Routing = ({data:permissionFromApi}) => {
  const isLoggedIn = useSelector((state) => state.auth.token);
  if(isLoggedIn){
    if (!permissionFromApi) {
      return <div><Loader /></div>; 
    }
  }
  
  
  return <>{isLoggedIn ? <MainRoutes permissions={permissionFromApi}/> : <LoginRoutes />}</>;
};

export default Routing;
